import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const formatLabelText = (text = '') => text.trim().replace(/ /g, '-');

export const getClassroomEventLabel = ({ id, title, contentType }) => {
  const courseCode = id ?? 'Unknown';
  const sectionTitle = title ?? 'Unknown';
  const currentContentType = contentType ?? 'Unknown';

  const courseCodeFormatted = formatLabelText(courseCode);
  const sectionTitleFormatted = formatLabelText(sectionTitle);
  const contentTypeFormatted = formatLabelText(currentContentType);

  const label = `C:${courseCodeFormatted}|S:${sectionTitleFormatted}|SS:${contentTypeFormatted}`;
  return label;
};

export const formatBangkokTime = (time = dayjs()) => {
  const dayjsTime = dayjs(time);
  return dayjsTime.isValid()
    ? dayjsTime.tz('Asia/Bangkok').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
    : '-';
};
